<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <hr />

    <transactions :id="id" />
    <div class="save-panel">
      <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import Transactions from "./Transactions";

export default {
  components: {
    QrcodeVue,
    Transactions,
  },
  data: () => ({
    cardLink: "clients",
    cardSetLink: "clients",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
        readonly: true,
      },
      //   {
      //   col:' col-12 col-md-3',
      //   key: "bonus",
      //   label: "Бонусы",
      //   type: "field",
      //   textType: "number",
      //   readonly:true
      // },
      {
        col: " col-12 col-md-6",
        key: "last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
        readonly: true,
      },
      {
        col: " col-12 col-md-6",
        key: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
        readonly: true,
      },
      {
        col: " col-12 col-md-6",
        key: "bonus",
        label: "Бонусы",
        type: "field",
        textType: "text",
        readonly: true,
      },
      // {
      //   col:' col-12 col-md-6',
      //   key: "role",
      //   label: "Роль",
      //   type: "select",
      //   modal: "role",
      //   selectKey: "title",
      // },
      //new
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item && item.id) {
        setTimeout(() => {
          this.item["dealer_temp"] = item["dealer_temp"];
          this.item["is_active"] = item["is_active"];
        }, 50);
      }
    },
  },
};
</script>
<style>
</style>
